"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotFoundError = void 0;
var core_1 = require("@moralisweb3/core");
function isNotFoundError(e) {
    var _a;
    if ((0, core_1.isMoralisError)(e)) {
        if (((_a = e.details) === null || _a === void 0 ? void 0 : _a.status) === 404) {
            return true;
        }
        if (e.code === core_1.ApiErrorCode.NOT_FOUND) {
            return true;
        }
    }
    return false;
}
exports.isNotFoundError = isNotFoundError;
